<template>
  <div class="content-wrap">
    <Form :bodyClass="''" :title="$t('containers.optionalData')" @submit="submitOptionalData" :collapsible="true">
      <TextInputField v-model="containerData.internal_id" :field="'internal_id'" />
      <div class="form-wrap select-wrap">
        <label for="condition">{{ $t('containers.condition') }}</label>
        <select v-model="containerData.condition" class="select-wrap">
          >
          <option v-for="index in 5" :key="index" :value="`cond${index}`">
            {{ $t(`containers.condition${index}`) }}
          </option>
          >
        </select>
      </div>
      <div class="form-wrap select-wrap">
        <label for="condition">{{ $t('containers.emptyMethod') }}</label>
        <select v-model="containerData.empty_method" class="select-wrap">
          <option value="emptying">
            {{ $t('containers.emptying') }}
          </option>
          <option value="exchange">
            {{ $t('containers.exchange') }}
          </option>
        </select>
      </div>
      <div class="col-8">
        <FormInput
          v-model="containerData.empty_duration"
          :name="$t('containers.emptyDuration')"
          type="number"
          min="0"
          max="120"
        />
      </div>
      <!-- Dropdown for container_type_group with custom input -->
      <div class="form-wrap select-wrap">
        <label for="container_type_group">{{ $t('containerTypes.containerTypeGroup') }}</label>
        <select v-model="containerData.type_container_type_group_name" class="select-wrap">
          <option v-for="f in containerTypeGroupValues" :value="f.name" :key="f.name">
            {{ f.localized_text }}
          </option>
        </select>
      </div>

      <TextInputField
        v-if="container.type_container_type_group_name === 'other'"
        :field="'custom_container_type_group'"
        v-model="containerData.custom_container_type_group"
        :modelTranslationKey="'containerTypes'"
        :placeholder="$t('containerTypes.containerTypeGroupPlaceholder')"
      />

      <!-- Dropdown for manufacturer with custom input -->
      <div class="form-wrap select-wrap">
        <label for="manufacturer">{{ $t('containerTypes.manufacturer') }}</label>
        <select v-model="containerData.type_manufacturer_name" class="select-wrap">
          <option v-for="f in manufacturerValues" :value="f.name" :key="`manufacturer-${f.name}`">
            {{ f.localized_text }}
          </option>
        </select>
      </div>
      <TextInputField
        v-if="container.type_manufacturer_name === 'other'"
        v-model="containerData.custom_manufacturer"
        :field="'custom_manufacturer'"
        :modelTranslationKey="'containerTypes'"
        :placeholder="$t('containerTypes.manufacturerPlaceholder')"
      />

      <!-- Dropdown for fraction -->
      <div class="form-wrap select-wrap">
        <label for="fraction">{{ $t('containerTypes.fraction') }}</label>
        <select v-model="containerData.fraction_uuid" class="select-wrap" id="fraction">
          <option v-for="fraction in fractions" :value="fraction.uuid" :key="fraction.uuid">
            {{ fraction.localized_name }}
          </option>
        </select>
      </div>

      <!-- Dropdown for pickup with custom input -->
      <div class="form-wrap select-wrap">
        <label for="pickup">{{ $t('containerTypes.pickup') }}</label>
        <select v-model="containerData.type_pickup_name" class="select-wrap">
          <option v-for="f in pickupValues" :value="f.name" :key="`pickup-${f.uuid}`">
            {{ f.localized_text }}
          </option>
        </select>
      </div>
      <TextInputField
        v-if="containerData.type_pickup_name === 'other'"
        v-model="containerData.custom_pickup"
        :field="'custom_pickup'"
        :modelTranslationKey="'containerTypes'"
        :placeholder="$t('containerTypes.pickupPlaceholder')"
      />
      <!-- Dropdown for body_color with custom input -->
      <div class="form-wrap select-wrap">
        <label for="body_color">{{ $t('containerTypes.bodyColor') }}</label>
        <select v-model="containerData.type_body_color_name" class="select-wrap" id="body_color">
          <option v-for="f in bodyColorValues" :value="f.name" :key="`color-${f.uuid}`">
            {{ f.localized_text }}
          </option>
        </select>
      </div>
      <TextInputField
        v-if="containerData.type_body_color_name === 'other'"
        :field="'custom_body_color'"
        v-model="containerData.custom_body_color"
        :modelTranslationKey="'containerTypes'"
        :placeholder="$t('containerTypes.bodyColorPlaceholder')"
      />
      <!-- Dropdown for cover_color with custom input -->
      <div class="form-wrap select-wrap">
        <label for="cover_color">{{ $t('containerTypes.coverColor') }}</label>
        <select v-model="containerData.type_cover_color_name" class="select-wrap">
          <option v-for="f in coverColorValues" :value="f.name" :key="`cover-${f.uuid}`">
            {{ f.localized_text }}
          </option>
        </select>
      </div>
      <TextInputField
        v-if="containerData.type_cover_color_name === 'other'"
        :field="'custom_cover_color'"
        v-model="containerData.custom_cover_color"
        :modelTranslationKey="'containerTypes'"
        :placeholder="$t('containerTypes.coverColorPlaceholder')"
      />
      <div class="form-wrap select-wrap">
        <label for="groundShape">{{ $t('containerTypes.groundShape') }}</label>
        <select v-model="containerData.type_ground_shape" class="select-wrap">
          <option value="round">
            {{ $t('containerTypes.roundBase') }}
          </option>
          <option value="square">
            {{ $t('containerTypes.squareBase') }}
          </option>
        </select>
      </div>

      <div class="form-wrap select-wrap">
        <label for="pickup">{{ $t('containerTypes.coverCount') }}</label>
        <select v-model="containerData.type_cover_count" class="select-wrap">
          <option value="without_cover">
            {{ $t('containerTypes.withoutCover') }}
          </option>
          <option value="one_cover">1 {{ $t('containerTypes.cover') }}</option>
          <option value="two_covers">2 {{ $t('containerTypes.cover') }}</option>
          <option value="four_covers">4 {{ $t('containerTypes.cover') }}</option>
          <option value="six_covers">6 {{ $t('containerTypes.cover') }}</option>
        </select>
      </div>

      <div class="form-wrap select-wrap">
        <label for="compressor">{{ $t('containerTypes.compressor') }}</label>
        <select v-model="containerData.type_compressor" class="select-wrap">
          <option value="bulk_waste_press">
            {{ $t('containerTypes.bulkWasteCompressor') }}
          </option>
          <option value="wet_waste_compactor">
            {{ $t('containerTypes.wetWasteCompactor') }}
          </option>
          <option value="default_press">
            {{ $t('containers.standard') }}
          </option>
        </select>
      </div>

      <div class="row row-gutter-20">
        <div class="col-8">
          <FormInput v-model="containerData.type_width" :name="$t('containerTypes.width')" :type="'number'" :min="0" />
        </div>
        <div class="col-8">
          <FormInput
            v-model="containerData.type_length"
            :name="$t('containerTypes.length')"
            :type="'number'"
            :min="0"
          />
        </div>
        <div class="col-8">
          <FormInput
            v-model="containerData.type_height"
            :name="$t('containerTypes.height')"
            :type="'number'"
            :min="0"
          />
        </div>
      </div>

      <FormInput
        v-model="containerData.type_insertion_height"
        :name="$t('containerTypes.insertionHeight')"
        :type="'number'"
        :min="0"
      />

      <div class="row row-gutter-20">
        <div class="col-8">
          <FormInput
            v-model="containerData.type_total_weight"
            :type="'number'"
            :min="0"
            :name="$t('containerTypes.totalWeight')"
          />
        </div>
        <div class="col-8">
          <FormInput
            v-model="containerData.type_tare_weight"
            :type="'number'"
            :min="0"
            :name="$t('containerTypes.tareWeight')"
          />
        </div>
      </div>

      <div class="content-meta" id="sensor-settings">
        <div class="meta-header">
          <h3>{{ $t('containerTypes.sensorSettings') }}</h3>
        </div>
        <div class="meta-body">
          <FormInput
            v-model="containerData.type_distance"
            :type="'number'"
            :min="0"
            :name="$t('containerTypes.distanceSensorBottom')"
          />
          <div class="row row-gutter-20">
            <div class="col-12">
              <FormInput
                v-model="containerData.type_distance_full"
                :type="'number'"
                :min="0"
                :name="$t('containerTypes.distanceFull')"
                :class="{
                  'missing-data-field': highlightedMissingData,
                }"
              />
            </div>
            <div class="col-12">
              <FormInput
                v-model="containerData.type_distance_empty"
                :type="'number'"
                :min="0"
                :name="$t('containerTypes.distanceEmpty')"
                :class="{
                  'missing-data-field': highlightedMissingData,
                }"
              />
            </div>
          </div>
        </div>
      </div>

      <FormSection :name="$t('containers.nameplate')" :childrenCount="1">
        <div>
          <div class="row row-gutter-20">
            <div class="col-8">
              <TextInputField v-model="containerData.plate_serial_number" :field="'serial_number'" />
            </div>
            <div class="col-8">
              <TextInputField v-model="containerData.plate_year" :field="'plate_year'" />
            </div>
            <div class="col-8">
              <TextInputField v-model="containerData.plate_description" :field="'plate_description'" />
            </div>
          </div>
          <div class="form-wrap">
            <label for="badge">{{ $t('containers.nameplatePicture') }}</label>
            <input type="file" accept="image/*" @change="setNamePlate" />
          </div>
          <Table v-if="containerData.name_plate">
            <template #header>
              <th>{{ $t('meta.image') }}</th>
              <th>{{ $t('meta.addedOn') }}</th>
            </template>
            <template #body>
              <tr>
                <td>
                  <ImageComponent
                    :preview="containerData.name_plate.preview_url"
                    :src="containerData.name_plate.url"
                    :height="'100'"
                  />
                </td>
                <td>{{ formattedFromDateTime(containerData.name_plate.created_at) }}</td>
              </tr>
            </template>
          </Table>
        </div>
      </FormSection>
      <FormSection :name="$t('containers.customersContainer')" :childrenCount="1">
        <div>
          <div class="row row-gutter-20">
            <div class="col-12">
              <BooleanRadioField
                :field="'fixed_location'"
                v-model="containerData.fixed_location"
                name="fixed_location"
              />
            </div>
            <div class="col-12">
              <BooleanRadioField
                :field="'customer_owned'"
                v-model="containerData.customer_owned"
                name="customer_owned"
              />
            </div>
          </div>
          <div class="row row-gutter-20">
            <div class="col-6">
              <TextInputField v-model="containerData.name_location_customer" :field="'name_location_customer'" />
            </div>
            <div class="col-6">
              <TextInputField v-model="containerData.name_location_number" :field="'name_location_number'" />
            </div>
            <div class="col-6">
              <TextInputField v-model="containerData.contract_number" :field="'contract_number'" />
            </div>
            <div class="col-6">
              <TextInputField v-model="containerData.contract_item" :field="'contract_item'" />
            </div>
          </div>

          <div class="form-wrap">
            <label for="description">{{ $t('containers.customizedDescription') }}</label>
            <textarea
              v-model="containerData.customized_description"
              class="form-input"
              name="description"
              id="description"
              rows="3"
            ></textarea>
          </div>

          <div class="form-wrap">
            <label for="badge">{{ $t('containers.customizedPicture') }}</label>
            <input type="file" accept="image/*" @change="setCustomFeature" />
          </div>
          <Table v-if="containerData.custom_feature">
            <template #header>
              <th>{{ $t('meta.image') }}</th>
              <th>{{ $t('meta.addedOn') }}</th>
            </template>
            <template #body>
              <tr>
                <td>
                  <ImageComponent
                    :preview="containerData.custom_feature.preview_url"
                    :src="containerData.custom_feature.url"
                    :height="'100'"
                  />
                </td>
                <td>{{ formattedFromDateTime(containerData.custom_feature.created_at) }}</td>
              </tr>
            </template>
          </Table>
        </div>
      </FormSection>
      <Button type="submit" fullWidth>{{ $t('meta.save') }}</Button>
    </Form>
  </div>
</template>

<script>
import Button from '@/components/Button/index.vue'
import FormInput from '@/components/Form/Input/index.vue'
import FormSection from '@/components/Form/Section/index.vue'
import Form from '@/components/Form/index.vue'
import ImageComponent from '@/components/Image.vue'
import Table from '@/components/Table/index.vue'
import BooleanRadioField from '@/components/container/BooleanRadioField.vue'
import TextInputField from '@/components/container/TextInputField.vue'
import dateUtils from '@/components/mixins/dateUtils'

import categoryValuesApi from '@/api/categoryValues'
import fractionsApi from '@/api/companies/fractions'
import containerApi from '@/api/container'

const SUPPORTED_ATTRIBUTES = [
  'custom_body_color',
  'custom_container_type_group',
  'custom_cover_color',
  'custom_manufacturer',
  'custom_pickup',
  'customer_owned',
  'customized_description',
  'condition',
  'contract_item',
  'contract_number',
  'empty_method',
  'empty_duration',
  'fraction_uuid',
  'fixed_location',
  'internal_id',
  'name_location_customer',
  'name_location_number',
  'plate_description',
  'plate_serial_number',
  'plate_year',
  'type_body_color_name',
  'type_container_type_group_name',
  'type_compressor',
  'type_cover_color_name',
  'type_cover_count',
  'type_distance',
  'type_distance_empty',
  'type_distance_full',
  'type_ground_shape',
  'type_height',
  'type_insertion_height',
  'type_length',
  'type_manufacturer_name',
  'type_pickup_name',
  'type_tare_weight',
  'type_total_weight',
  'type_width',
]

export default {
  name: 'OptionalContainerData',
  inject: ['companyUser'],
  emits: ['refreshData'],
  components: {
    BooleanRadioField,
    Button,
    Form,
    FormInput,
    FormSection,
    Table,
    ImageComponent,
    TextInputField: TextInputField,
  },
  props: {
    container: {
      type: Object,
      required: true,
    },
    highlightedMissingData: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mixins: [dateUtils],
  data() {
    return {
      bodyColorValues: [],
      containerData: this.container,
      containerTypeGroupValues: [],
      coverColorValues: [],
      fractions: [],
      manufacturerValues: [],
      pickupValues: [],
      tempCustomFeature: '',
      tempNamePlate: '',
    }
  },
  watch: {
    container: {
      immediate: true,
      handler(newVal) {
        this.containerData = newVal
      },
      deep: true,
    },
  },
  methods: {
    setCustomFeature(event) {
      this.tempCustomFeature = event.target.files[0]
    },
    setNamePlate(event) {
      this.tempNamePlate = event.target.files[0]
    },
    async submitOptionalData() {
      const imageData = new FormData()
      if (this.tempNamePlate) {
        imageData.append('name_plate', this.tempNamePlate)
      }
      if (this.tempCustomFeature) {
        imageData.append('custom_feature', this.tempCustomFeature)
      }

      if ([...imageData.entries()].length > 0) {
        await containerApi.update(this.container.uuid, imageData)
      }

      const data = Object.fromEntries(
        SUPPORTED_ATTRIBUTES.map(attribute => [attribute, this.containerData[attribute]]) // get data from form
          .filter(([, value]) => value !== null && value !== undefined) // filter out values that have not been set
          .map(([attribute, value]) => [attribute, value === '' ? null : value]), // tells backend to reset empty fields
      )

      await containerApi.update(this.container.uuid, data)
      this.$emit('refreshData')
    },
  },
  async mounted() {
    if (this.container.fraction) {
      this.containerData.fraction_uuid = this.container.fraction.uuid
    }

    await Promise.all([
      (this.bodyColorValues = await categoryValuesApi.get('containers', 'body_color')),
      (this.coverColorValues = await categoryValuesApi.get('containers', 'cover_color')),
      (this.containerTypeGroupValues = await categoryValuesApi.get('container_types', 'container_type_group')),
      (this.manufacturerValues = await categoryValuesApi.get('container_types', 'manufacturer')),
      (this.pickupValues = await categoryValuesApi.get('container_types', 'pickup')),
      (this.fractions = await fractionsApi.getAll(this.companyUser.company.uuid)),
    ])
  },
}
</script>

<style lang="scss" src="./missing-data.scss" scoped />
